// client/src/components/layout/FormModal.js
import React from 'react';
import ReactDOM from 'react-dom';
import { XCircle } from 'lucide-react';

// ✅ MODIFICAÇÃO: Adicionada a prop 'headerControls'
const FormModal = ({ title, children, onClose, size = 'default', headerControls = null }) => {
    
    const handleContentClick = (e) => e.stopPropagation();

    const modalContent = (
        <div className="modal-overlay" onClick={onClose}>
            <div className={`modal-content form-modal-content modal--${size}`} onClick={handleContentClick}>
                <div className="form-header">
                    <h3 className="form-title">{title}</h3>
                    {/* ✅ MODIFICAÇÃO: Wrapper para alinhar os botões e renderizar os controles extras */}
                    <div className="flex items-center gap-2">
                        {headerControls}
                        <button type="button" onClick={onClose} className="form-close-button">
                            <XCircle size={24}/>
                        </button>
                    </div>
                </div>
                
                <div className="modal-body with-padding">
                    {children}
                </div>
            </div>
        </div>
    );
    
    return ReactDOM.createPortal(modalContent, document.getElementById('modal-root'));
};

export default FormModal;